import { LayerOrientation, } from "@buildwithflux/models";
import { Euler, Vector2, Vector3 } from "three";
const bottomFlipEuler = new Euler(0, Math.PI, 0);
/**
 * Given a route segment, returns the absolute position of the start and end.
 * It's also possible to pass a position to override the current one (to calculate the new start/end after dragging).
 */
export function getNodeAbsVertexPosition(vertex, node, parent, newPos) {
    const parentPosition = parent.bakedRules.positionRelativeToDocument;
    const parentRotation = parent.bakedRules.rotationRelativeToDocument;
    const parentPositionV3 = new Vector3(parentPosition.x, parentPosition.y, parentPosition.z);
    const parentRotationV3 = new Euler(parentRotation.x, parentRotation.y, parentRotation.z);
    const parentIsBottom = parent.bakedRules.layer === LayerOrientation.bottom;
    const position = newPos ?? node.bakedRules.position ?? { x: 0, y: 0, z: 0 };
    const rotation = node.bakedRules.rotation ?? { x: 0, y: 0, z: 0 };
    const positionVec3 = new Vector3(position.x, position.y, position.z);
    const rotationVec3 = new Euler(rotation.x, rotation.y, rotation.z);
    const vertexVec3 = new Vector3(vertex.x, vertex.y, vertex.z);
    // Only flip if EITHER the trace OR the parent is on the bottom layer (XOR)
    // If parent is undefined, `parentIsBottom` will be false, so the XOR will be true
    const traceIsBottom = node.bakedRules.layer === LayerOrientation.bottom;
    if (traceIsBottom !== parentIsBottom) {
        vertexVec3.applyEuler(bottomFlipEuler);
    }
    vertexVec3.applyEuler(rotationVec3).add(positionVec3).applyEuler(parentRotationV3).add(parentPositionV3);
    return new Vector2(vertexVec3.x, vertexVec3.y);
}
/**
 * Given a route segment, returns the absolute position of the start and end.
 * It's also possible to pass a position to override the current one (to calculate the new start/end after dragging).
 */
export function getRouteSegmentAbsStartEndPos(node, allNodes, newPos) {
    const parent = allNodes[node.parentUid]; // TODO: fix, bad to assume type by blindly casting
    const positionForVertex = newPos ? { x: newPos.x, y: newPos.y, z: 0 } : undefined;
    const start = getNodeAbsVertexPosition(node.bakedRules.startPosition, node, parent, positionForVertex);
    const end = getNodeAbsVertexPosition(node.bakedRules.endPosition, node, parent, positionForVertex);
    return [start, end];
}
//# sourceMappingURL=getRouteSegmentAbsStartEndPos.js.map